import React from 'react'
import {ActionButton} from '@agillic/agillic-ui'
import localeData from '../helpers/login.lang'

const language = 'en'
const locale = localeData[language]

const Instruction = () => (
  <div className='cannotConnect'>
    <i className='illustration fas fa-wrench' />
    <p>{locale.instanceIsDown()}</p>
    <ActionButton
      color='green'
      icon='fas fa-paper-plane'
      onClick={event => {
        event.target.classList.add('pending')
        window.top.location.replace('https://support.agillic.com/hc/en-gb')
      }}
    >
      {locale.contactCustomerService()}
    </ActionButton>
  </div>
)

export default Instruction
